
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universitetlar/[id]",
      function () {
        return require("private-next-pages/universitetlar/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/universitetlar/[id]"])
      });
    }
  